import type { NavItem } from '../../types'
import { cn } from '../../utils/cn'
import { NavAction } from './NavAction'

type RailIconButtonProps = {
  item: NavItem
  active?: boolean
  onSelect?: (id: string) => void
}

export const RailIconButton = ({ item, active = false, onSelect }: RailIconButtonProps) => (
  <NavAction
    item={item}
    active={active}
    onSelect={onSelect}
    label={item.label}
    className="relative block size-[35px] shrink-0 overflow-hidden"
  >
    <span
      className={cn(
        'absolute inset-x-0 bottom-[5%] top-[1.66%] flex items-center justify-center overflow-hidden rounded-full px-[2.27px] py-[1.513px]',
        active ? 'bg-dash-peach' : 'bg-white',
      )}
    >
      <img
        alt=""
        aria-hidden
        src={item.icon}
        style={{ width: item.glyph.width, height: item.glyph.height }}
        className={cn('block max-w-none shrink-0', item.mirrored && '-scale-x-100')}
      />

      {item.badge === 'dot' && (
        <span className="absolute right-[4px] top-[4px] block size-[7px] rounded-full bg-[#4CAF50] ring-1 ring-white" />
      )}
    </span>
  </NavAction>
)
